import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(p){ super(p); this.state={hasError:false,msg:"",stack:""} }
  static getDerivedStateFromError(e){ return {hasError:true,msg:e?.message||String(e)} }
  componentDidCatch(e, info){ console.error("App crashed:", e, info); this.setState({stack:e?.stack||""}) }
  render(){
    if(this.state.hasError){
      return (
        <div style={{minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",background:"#f8fafc"}}>
          <div style={{border:"1px solid #fecaca",background:"#fff",padding:16,borderRadius:12,maxWidth:700,width:"92%"}}>
            <div style={{color:"#b91c1c",fontWeight:700,marginBottom:8}}>Errore di inizializzazione</div>
            <pre style={{whiteSpace:"pre-wrap",fontFamily:"monospace",fontSize:13}}>{this.state.msg}</pre>
            {this.state.stack ? (
              <details style={{marginTop:10}}>
                <summary>Dettagli tecnici</summary>
                <pre style={{fontFamily:"monospace",fontSize:12}}>{this.state.stack}</pre>
              </details>
            ):null}
          </div>
        </div>
      )
    }
    return this.props.children;
  }
}
